<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <b-card no-body>
      <b-tabs pills card>
        <b-tab title="Filtros">
          <b-row>
            <b-col xl="4" lg="4" md="4" sm="12">
              <b-input-group prepend="Data Inicial" class="date-input">
                <datepicker
                  class="form-control"
                  placeholder="Escolha a data"
                  v-model="datainicial"
                  :language="ptBR"
                  :format="customFormatter"
                  :key="disabledDatesStart != null"
                  @selected="mudaDataInicial"
                ></datepicker>
              </b-input-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12">
              <b-input-group prepend="Data Final" class="date-input">
                <datepicker
                  class="form-control"
                  placeholder="Escolha a data"
                  v-model="datafinal"
                  :language="ptBR"
                  :format="customFormatter"
                  @selected="mudaDataFinal"
                  :disabledDates="disabledDatesEnd"
                  :key="disabledDatesEnd != null"
                ></datepicker>
              </b-input-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12">
              <b-button @click="gerarAnalise" variant="primary" class="m-w"
                >Gerar análise</b-button
              >
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row>
      <b-col cols="12">
        <b-card v-if="this.qtdCampanhas > 0">
          <h3 class="f-g text-center">
            Período analisado: {{ moment(datainicial).format("DD/MM/YYYY") }} a
            {{ moment(datafinal).format("DD/MM/YYYY") }}, com
            {{ qtdCampanhas }} campanhas.
          </h3>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card
          class="text-center"
          header="Envios de Push"
          v-if="
            items_detalhamento_envio == null || items_detalhamento_envio == []
          "
        >
          <i class="fa fa-hdd-o fa-custom-size"></i>
          <h6>Sem resultados para o filtro aplicado</h6>
        </b-card>

        <b-card class="text-center" header="Envios de Push" v-else>
          <b-table
            bordered
            responsive="sm"
            :items="items_detalhamento_envio"
            thead-class="hidden_header"
          ></b-table>
        </b-card>
      </b-col>

      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card
          class="text-center"
          header="Gráfico - Envios de Push"
          v-if="enviadas == null && rejeitadas == null"
        >
          <i class="fa fa-bar-chart fa-custom-size"></i>
          <h6>Sem resultados para o filtro aplicado</h6>
        </b-card>

        <b-card
          b-card
          class="text-center"
          header="Gráfico - Envios de Push"
          v-else
        >
          <envios-de-push
            v-if="readyToShow"
            :enviadas="enviadas"
            :rejeitadas="rejeitadas"
            :height="185"
          ></envios-de-push>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card
          class="text-center"
          header="Visualizações e compras"
          v-if="
            items_visualizacoes_compras == null ||
            items_visualizacoes_compras == []
          "
        >
          <i class="fa fa-hdd-o fa-custom-size"></i>
          <h6>Sem resultados para o filtro aplicado</h6>
        </b-card>
        <b-card class="text-center" header="Visualizações e compras" v-else>
          <b-table
            bordered
            responsive="sm"
            :items="items_visualizacoes_compras"
            thead-class="hidden_header"
          ></b-table>
        </b-card>
      </b-col>

      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card
          class="text-center"
          header="Gráfico - Visualizações e compras"
          v-if="enviadas == null && visualizadas == null"
        >
          <i class="fa fa-bar-chart fa-custom-size"></i>
          <h6>Sem resultados para o filtro aplicado</h6>
        </b-card>
        <b-card
          class="text-center"
          header="Gráfico - Visualizações e compras"
          v-else
        >
          <visualizacoes-compras
            v-if="readyToShow"
            :recebidas="enviadas"
            :visualizadas="visualizadas"
            :compraram="compraram"
            :height="185"
          ></visualizacoes-compras>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card
          class="text-center"
          header="Clientes no período"
          v-if="items_clientes_periodo == null || items_clientes_periodo == []"
        >
          <i class="fa fa-hdd-o fa-custom-size"></i>
          <h6>Sem resultados para o filtro aplicado</h6>
        </b-card>
        <b-card class="text-center" header="Clientes no período" v-else>
          <b-table
            bordered
            responsive="sm"
            :items="items_clientes_periodo"
            thead-class="hidden_header"
          ></b-table>
        </b-card>
      </b-col>

      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card
          class="text-center"
          header="Gráfico - Clientes no período"
          v-if="
            clientes_identificados == null &&
            clientes_nao_identificados == null &&
            compraram == null
          "
        >
          <i class="fa fa-bar-chart fa-custom-size"></i>
          <h6>Sem resultados para o filtro aplicado</h6>
        </b-card>
        <b-card
          class="text-center"
          header="Gráfico - Clientes no período"
          v-else
        >
          <clientes-no-periodo
            v-if="readyToShow"
            :identificados="clientes_identificados"
            :naoidentificados="clientes_nao_identificados"
            :compraram="compraram"
            :height="185"
          ></clientes-no-periodo>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card
          class="text-center"
          header="Clientes no período"
          v-if="
            datasetIdentificados == null &&
            datasetNaoIdentificados == null &&
            datasetFidelizados == null
          "
        >
          <i class="fa fa-area-chart fa-custom-size"></i>
          <h6>Sem resultados para o filtro aplicado</h6>
        </b-card>
        <b-card class="text-center" header="Clientes no período" v-else>
          <visualizacoes-compras-line
            v-if="readyToShow"
            :labels="datasetLabels"
            :identificados="datasetIdentificados"
            :naoidentificados="datasetNaoIdentificados"
            :fidelizados="datasetFidelizados"
          ></visualizacoes-compras-line>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import axios from "axios";
import * as config from "@/config.json";
import Loading from "vue-loading-overlay";
import moment from "moment";
import EnviosDePush from "../../charts/EnviosDePush";
import VisualizacoesCompras from "../../charts/VisualizacoesCompras";
import ClientesNoPeriodo from "../../charts/ClientesNoPeriodo";
import VisualizacoesComprasLine from "../../charts/VisualizacoesComprasLine";

export default {
  components: {
    Datepicker,
    Loading,
    moment,
    EnviosDePush,
    VisualizacoesCompras,
    ClientesNoPeriodo,
    VisualizacoesComprasLine,
  },
  data: () => {
    return {
      datainicial: null,
      datafinal: null,
      ptBR: ptBR,
      disabledDatesStart: null,
      disabledDatesEnd: null,
      isLoading: false,
      items_detalhamento_envio: null,
      items_visualizacoes_compras: null,
      items_clientes_periodo: null,
      enviadas: null,
      rejeitadas: null,
      visualizadas: null,
      compraram: null,
      readyToShow: false,
      clientes_identificados: null,
      clientes_nao_identificados: null,
      datasetLabels: null,
      datasetIdentificados: null,
      datasetNaoIdentificados: null,
      datasetFidelizados: null,
      items_resultados: null,
      faturado: null,
      qtdCampanhas: null,
    };
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatDate(dataIni, dataFim) {
      this.datainicial = moment(dataIni).format("YYYY-MM-DD 00:00:00");
      this.datafinal = moment(dataFim).format("YYYY-MM-DD 23:59:59");
    },
    async mudaDataFinal(data) {
      if (data) {
        localStorage.setItem("datafinal_analise", data);
        this.disabledDatesStart = null;
        this.disabledDatesStart = {};
        this.disabledDatesStart.from = new Date(data);
      }
    },
    async mudaDataInicial(data) {
      if (data) {
        localStorage.setItem("datainicial_analise", data);
        this.disabledDatesEnd = null;
        this.disabledDatesEnd = {};
        this.disabledDatesEnd.to = new Date(data);
        this.disabledDatesEnd.from = new Date();
      }
    },

    async gerarAnalise() {
      await this.formatDate(this.datainicial, this.datafinal);

      const url = `${
        config.default.servidor
      }/gerencial/checa-campanhas/${localStorage.getItem("enterprise_id")}/${
        this.datainicial
      }/${this.datafinal}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          if (!response.data.error && response.data.campanhas) {
            localStorage.setItem("datainicial", this.datainicial);
            localStorage.setItem("datafinal", this.datafinal);
            localStorage.setItem("qtdCampanhas", response.data.qtd);

            this.qtdCampanhas = localStorage.getItem("qtdCampanhas");

            await this.getTotalizadoresCampanhas();
            await this.getClientesCompraram();
            await this.getDatasetClientes();
            await this.getResultados();

            this.readyToShow = true;

            //this.$router.push({ path: "analise" });
          } else {
            await this.$alert(
              `Não foram encontradas campanhas no período selecionado. Data Inicial: ${moment(
                this.datainicial
              ).format("DD/MM/YYYY")}. \nData Final: ${moment(
                this.datafinal
              ).format("DD/MM/YYYY")}.`,
              "Aviso",
              "warning"
            );
          }
        }
      } catch (error) {
        console.log({ error });
        await this.$alert(
          `Falha ao buscar campanhas no período selecionado. Data Inicial: ${moment(
            this.datainicial
          ).format("DD/MM/YYYY")}. \nData Final: ${moment(
            this.datafinal
          ).format("DD/MM/YYYY")}.`,
          "Erro",
          "error"
        );
      }
    },

    async getClientesCompraram() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-clientes-que-compraram/${localStorage
        .getItem("enterprise_id")
        .toString()}/${this.datainicial}/${this.datafinal}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          if (response.data) {
            var arr = [];

            this.compraram =
              response.data[0].qtd + response.data[1].qtd;
              
            arr.push({
              descricao: "Recebidos",
              valor: parseFloat(this.enviadas),
            });

            arr.push({ 
              descricao: "Visualizados", 
              valor: this.visualizadas });

            arr.push({ 
              descricao: "Compras", 
              valor: this.compraram });

            arr.push({
              descricao: "Taxa de conversão",
              valor: `${parseFloat(
                (this.compraram * 100) / this.enviadas
              ).toFixed(2)}%`,
            });

            this.items_visualizacoes_compras = arr;


            this.items_clientes_periodo = [];
            this.clientes_identificados = response.data[1].qtd;
            this.clientes_nao_identificados = response.data[0].qtd;
            this.items_clientes_periodo.push({
              descricao: "Identificados",
              valor: this.clientes_identificados,
            });
            this.items_clientes_periodo.push({
              descricao: "Não identificados",
              valor: this.clientes_nao_identificados,
            });
            this.items_clientes_periodo.push({
              descricao: "Compras",
              valor: this.compraram,
            });

            if (this.clientes_identificados > 0) {
              this.items_clientes_periodo.push({
                descricao: "Taxa de impacto",
                valor: `${parseFloat(
                  (this.compraram * 100) / this.clientes_identificados
                ).toFixed(2)}%`,
              });
            } else {
              this.items_clientes_periodo.push({
                descricao: "Taxa de impacto",
                valor: 0,
              });
            }
          } else this.items_visualizacoes_compras = [];
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async getTotalizadoresCampanhas() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-totalizador-campanhas/${localStorage
        .getItem("enterprise_id")
        .toString()}/${this.datainicial}/${this.datafinal}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          if (response.data) {
            this.visualizadas = response.data.pushsvisualizados;

            if (response.data.detalhamento_envio) {
              this.items_detalhamento_envio = response.data.detalhamento_envio;

              for (let i = 0; i < this.items_detalhamento_envio.length; i++) {
                const e = this.items_detalhamento_envio[i];
                if (e.descricao == "Recebidos") this.enviadas = e.valor;
                if (e.descricao == "Rejeitados") this.rejeitadas = e.valor;
              }
            } else this.items_detalhamento_envio = [];
          }
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async getDatasetClientes() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-dataset-clientes/${localStorage
        .getItem("enterprise_id")
        .toString()}/${this.datainicial}/${this.datafinal}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          const e = response.data.data;
          this.datasetLabels = e.arrLabels;
          this.datasetIdentificados = e.arrCom;
          this.datasetNaoIdentificados = e.arrSem;
          this.datasetFidelizados = e.arrFid;
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async getResultados() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-resultados/${localStorage
        .getItem("enterprise_id")
        .toString()}/${this.datainicial}/${this.datafinal}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          const e = response.data.data;
          this.faturado = e.total.toFixed(2);
          this.items_resultados = [
            { descricao: "Compras geradas", valor: e.qtd },
            { descricao: "Ticket médio", valor: `R$${e.ticket.toFixed(2)}` },
            { descricao: "Total faturado", valor: `R$${this.total}` },
          ];
        }
      } catch (error) {
        console.log({ error });
      }
    },
  },

  async beforeMount() {
    this.isLoading = true;

    this.datainicial = moment().startOf("month").format("YYYY-MM-DD hh:mm");
    this.datafinal = new moment()
      .add(1, "months")
      .date(1)
      .format("YYYY-MM-DD hh:mm");
    this.disabledDatesStart = {};
    this.disabledDatesStart.from = new Date(this.datafinal);

    this.disabledDatesEnd = {};
    this.disabledDatesEnd.to = new Date(this.datainicial);

    this.isLoading = false;
  },
};
</script>
